var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isModeFetching
        ? _vm._t("fetching", function () {
            return [_vm._m(0)]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isModeNoContent
        ? _vm._t("no-content", function () {
            return [
              _c("div", { staticClass: "text-center" }, [_vm._v("No Content")]),
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isModeError
        ? _vm._t("fetching", function () {
            return [
              _c("div", { staticClass: "text-center" }, [
                _vm._v("Server Error"),
              ]),
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isModeDisplay
        ? _c("div", { domProps: { innerHTML: _vm._s(_vm.content) } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("i", { staticClass: "fas fa-circle-notch fa-spin" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }